import { Component, EventEmitter, Output } from '@angular/core';
import {CustomInputComponent} from "../custom-input/custom-input.component";
import {debounceTime, Subject} from "rxjs";
import {CommonModule} from "@angular/common";
import {TooltipDirective} from "../../../shared/tooltip/tooltip.directive";

@Component({
  selector: 'app-custom-search-input',
  templateUrl: './custom-search-input.component.html',
  standalone: true,
  imports: [
    CustomInputComponent, CommonModule, TooltipDirective
  ],
  styleUrls: ['./custom-search-input.component.scss']
})
export class CustomSearchInputComponent extends CustomInputComponent {
  private search$ = new Subject<string>();
  @Output() searchChange = new EventEmitter<string>();

  constructor() {
    super();
    this.search$.pipe(debounceTime(500)).subscribe((search) => {
      this.searchChange.emit(search);
    });
  }
  onSearchClick(e: string) {
    this.search$.next(e);
  }

  onRemoveClick(){
    this.val = '';
    this.searchChange.emit('');
  }
}
